import { observable, action, computed } from 'mobx'
import { typeFromId } from '../../utils/FlyBaseIds'
import { serializable, identifier, map } from 'serializr'
import { v4 } from 'uuid'

class DataClassFilter {
  @serializable(identifier())
  _id = v4()

  @serializable(map())
  @observable
  selected = observable.map()

  @observable
  menuItems = observable.map()

  @action
  setMenuItems = (items) => {
    this.menuItems.replace(items)
  }

  @action
  selectItem = (dataClass) => {
    if (this.menuItems.has(dataClass)) {
      this.selected.set(dataClass, null)
    }
  }

  @action
  deSelectItem = (dataClass) => this.selected.delete(dataClass)
  @action
  clear = () => this.selected.clear()

  @computed
  get selectedItems() {
    return [...this.selected.keys()]
  }

  isSelected(dataClass) {
    return this.selected.has(dataClass)
  }

  getCount(dataClass) {
    const item = this.getDataClass(dataClass)
    return item ? item.count : 0
  }

  @action
  setCount(dataClass, count = 0) {
    const item = this.getDataClass(dataClass)
    if (item) item.count = count
  }

  getLabel(dataClass) {
    const item = this.getDataClass(dataClass)
    return item ? item.label : null
  }

  getDataClass(dataClass) {
    if (this.menuItems.has(dataClass)) {
      return this.menuItems.get(dataClass)
    }
    return null
  }

  static filterIdsByDataClass(ids = [], opts = { dataClasses: [] }) {
    const dcWanted = opts.dataClasses

    return ids.filter((id) => {
      const type = typeFromId(id)
      return dcWanted.length > 0 ? dcWanted.indexOf(type) >= 0 : true
    })
  }
}

export default DataClassFilter
